import AXIOS from "./axios";

export class Operator {
  static login({ email, password }) {
    return AXIOS.post("/operator_auth/sign_in", { email, password });
  }

  static register(payload) {
    return AXIOS.post("/institutions/operators", { operator: payload });
  }

  static logout() {
    return AXIOS.delete("/operator_auth/sign_out");
  }

  static forgotPassword(payload) {
    payload.redirect_url =
      process.env.VUE_APP_FORGOT_PASSWORD_REDIRECT_URL || "";
    return AXIOS.post("/operator_auth/password", { ...payload });
  }

  static updatePassword({ password, password_confirmation, headers }) {
    return AXIOS.put(
      "/operator_auth/password",
      { password, password_confirmation },
      { headers: { ...headers } }
    );
  }

  static update(operator) {
    const data = { ...operator };
    delete data.id;
    return AXIOS.put(`/institutions/operators/${operator.id}`, {
      operator: data
    });
  }

  static show(id) {
    return AXIOS.get(`/institutions/operators/${id}`);
  }

  static fetchUsersLocation() {
    return AXIOS.get(`/institutions/users`);
  }

  static fetchUserInstitutions(accountType) {
    return AXIOS.get(
      `/institutions/user_institutions?account_type=${accountType}`
    );
  }

  static fetchAlerts() {
    return AXIOS.get(`/institutions/alerts`);
  }

  static showAlert(Id) {
    return AXIOS.get(`/institutions/alerts/${Id}`);
  }

  static updateUserStatus(data) {
    const { user: object } = data;
    const user = (({ status }) => ({ status }))(object);
    return AXIOS.put(`/institutions/users/${object.id}`, { user });
  }

  static fetchUserInstitutionSymptoms(id) {
    return AXIOS.get(`/institutions/users/${id}/symptoms`);
  }
}
